import { Container } from "react-bootstrap";

export default function TwoFactorAuth() {
  return (
    <>
      <Container fluid>
        Two FA Auth
      </Container>
    </>
  );
}
